import { get } from 'lodash-es';
import React, { useEffect } from 'react';
import { useLazyQuery } from 'react-apollo';
import { useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { handleRequestError } from '../../constants/errorCodes';
import { TICKET_STATUS_CLOSED, TICKET_STATUS_INITIATED, TICKET_STATUS_IN_PROGRESS } from '../../constants/ticketing';
import { GetTicketCountQuery } from '../../operations/queries/GetTicketsQuery';
import { TicketCounter } from './TicketCounter';

export const AdminTicketingStatistics = ({ filters }) => {
  const dispatch = useDispatch();

  const [getCount, { data }] = useLazyQuery(GetTicketCountQuery, {
    onError: error => handleRequestError(error, dispatch),
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    const filterInitiated = {
      ...filters,
      status: TICKET_STATUS_INITIATED,
    };
    const filterInProgress = { ...filters, status: TICKET_STATUS_IN_PROGRESS };
    const filterClosed = { ...filters, status: TICKET_STATUS_CLOSED };
    const filterTotal = Object.keys(filters).reduce((obj, key) => {
      if (key === 'status') {
        return obj;
      }
      return {
        ...obj,
        [key]: filters[key],
      };
    }, {});

    getCount({
      variables: {
        filterInitiated,
        filterInProgress,
        filterClosed,
        filterTotal,
      },
    });
  }, [filters, getCount]);

  const initiatedCount = get(data, 'getTicketCountInitiated.queryCount', '--');
  const inProgressCount = get(data, 'getTicketCountInProgress.queryCount', '--');
  const closedCount = get(data, 'getTicketCountClosed.queryCount', '--');
  const totalCount = get(data, 'getTicketCountTotal.queryCount', '--');

  return (
    <Row className="no-gutters">
      <Col xs="12" md="3">
        <div className={'d-flex align-items-center justify-content-center flex-column red-border padding '}>
          <TicketCounter ticketCount={initiatedCount} headerTitle={'initiated'} />
        </div>
      </Col>
      <Col xs="12" md="3">
        <div className={'d-flex align-items-center justify-content-center flex-column red-border padding'}>
          <TicketCounter ticketCount={inProgressCount} headerTitle={'inProgress'} />
        </div>
      </Col>
      <Col xs="12" md="3">
        <div className={'d-flex align-items-center justify-content-center flex-column red-border padding'}>
          <TicketCounter ticketCount={closedCount} headerTitle={'closed'} />
        </div>
      </Col>
      <Col xs="12" md="3">
        <div className={'d-flex align-items-center justify-content-center flex-column padding'}>
          <TicketCounter ticketCount={totalCount} headerTitle={'total'} />
        </div>
      </Col>
    </Row>
  );
};
